module.exports = __webpack_public_path__ + "img/pic_2s.4278fce9.jpg";